<template>
  <div id="myCarousel" class="carousel slide" data-ride="carousel">
    <ol class="carousel-indicators">
      <li data-target="#myCarousel" :data-slide-to='index' v-for='(slide, index) in slides' :key='slide.id' :class="index == 0 ? 'active' : ''"></li>
    </ol>
    <div class="carousel-inner">

      <div class="carousel-item " v-for='(slide, index) in slides' :key='slide.id' :class="index == 0 ? 'active' : ''">
        <img class="w-100" :src='slide.img' :alt='slide.caption_title'>
        <div class="container">
          <div class="carousel-caption text-left">
            <h1>{{ slide.caption_title }}</h1>
            <p v-if='slide.caption_description'>{{ slide.caption_description }}</p>
            <ul v-if='slide.caption_list'>
              <li v-for='item_list in slide.caption_list' :key='item_list.id'>
                {{ item_list.text }}
              </li>
            </ul>

            <router-link class="btn btn-purple" v-if='slide.link' :to='slide.link'>Подробнее</router-link>
            <a class="btn btn-purple" v-else-if='slide.externalLink' :href='slide.externalLink' target="_blank">Подробнее</a>
          </div>
        </div>
      </div>

      <a class="carousel-control-prev" href="#myCarousel" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#myCarousel" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Carousel',
  data () {
    return {
      msg: '',
      slides: [
        {
          caption_title: 'Внедрение SuiteCRM с расширениями hs321',
          caption_list: [
            {text: 'Модуль разграничения доступа (группы, роли)'},
            {text: 'Модуль маршрутизации (BPM)'},
            {text: 'Модуль построения отчетов'},
            {text: 'Модуль аудирования действий пользователей'},
          ],
          img: '/static/img/carousel/1.jpg',
          link: '/products/suitecrm',
        },
        {
          caption_title: 'Waterman3',
          caption_description: 'ВАТЕРМАН - полнофункциональная биллинговая система учета начислений юридическим и физическим лицам для водоканалов. Эксплуатируется в АО «ОмскВодоканал» с 1997 года.',
          img: '/static/img/carousel/2.jpg',
          link: 'products/waterman3',
        },
        {
          caption_title: 'Блиц-аудит',
          caption_description: 'Быстрая диагностика состояния ИТ-ладншафта и возможных путей его развития в привязке к бизнес модели.',
          img: '/static/bsa-grey.jpg',
          externalLink: 'https://bush10.org/',
        },
      ]
    }
  }
}
</script>

<style scoped>
  @media (max-width: 575.98px) {
    .carousel-item img {
      min-height: 550px;
      object-fit: cover;
    }
    h1 {
      font-size: 2em;
    }
    .customers .card {
      border: 1px solid rgba(0,0,0,0);
    }
    .customers .card:hover {
      border: 1px solid rgba(0,0,0,.125);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/Carousel.vue